<!--
 * @Description: 
 * @Author: Roger Wei
 * @Date: 2021-11-23 16:37:49
 * @LastEditTime: 2021-11-28 16:02:31
 * @LastEditors: Roger Wei
 * @CopyRight: itence.com
 * @Reference: 
-->
<template>
    <div>
        <el-tree ref="templateTypeTree"  :data="data" node-key="key" default-expand-all  :expand-on-click-node="false" @node-click="checkNode">
            <!-- <span slot-scope="{ node,data }" class="custom-tree-node tree-line">
            </span> -->
        </el-tree>
    </div>
</template>

<script>
import TicketConf from '@/utils/ticketConf'
export default {
    props: {
        curType: {
            type: Object,
            default: null
        }
    },
    name: 'TemplateTypeList',
    data() {
        return {
            isHighLight: true,
            defaultKeys: [this.curType.key],
            data: TicketConf
        }
    },
    mounted() {
        this.$emit('changeType', { ...TicketConf[0].children[0], parentKey: TicketConf[0].key})
        this.$refs['templateTypeTree'].setCurrentKey('rawSupply')
    },
    methods: {
        checkNode(nodeData, node) {
            this.$emit('changeType', {...nodeData, parentKey: node.parent.data.key})
        }
    }
}
</script>